import { REMOVER_FILTRO_ROTA } from '../types'

export default function removerFiltroRota (filtro) {
  return {
    payload: filtro,
    type: REMOVER_FILTRO_ROTA
  }
}
